{
  "placeholder": "Code",
  "reloadCAPTCHA": "Regenerate verification code",
  "playCAPTCHA": "Play verification code audio",
  "error": {
    "required": "Please enter the verification code"
  }
}